<div *ngIf="spinner.show" >
  <div class="overlay"
       [ngClass]="spinner.class ? spinner.class : 'overlayDefaultBackground'"
       [style.position]="spinner.fullScreen ? 'fixed' : 'absolute'">
  </div>
  <div class="loader">
    <img alt="spinner" [src]="spinner.gif" />
  </div>
</div>
